/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_SubdomainAvailabilityResult } from '../models/Routemize_DTOs_SubdomainAvailabilityResult';
import type { Routemize_DTOs_TenantRegistrationDto } from '../models/Routemize_DTOs_TenantRegistrationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TenantRegistrationService {
    /**
     * @param paymentToken
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppTenantRegistrationCompleteRegistration(
        paymentToken?: string,
        requestBody?: Routemize_DTOs_TenantRegistrationDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/tenantRegistration/completeRegistration',
            query: {
                'paymentToken': paymentToken,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param subdomain
     * @returns Routemize_DTOs_SubdomainAvailabilityResult OK
     * @throws ApiError
     */
    public static postApiAppTenantRegistrationCheckSubdomainAvailability(
        subdomain?: string,
    ): CancelablePromise<Routemize_DTOs_SubdomainAvailabilityResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/tenantRegistration/checkSubdomainAvailability',
            query: {
                'subdomain': subdomain,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_TenantRegistrationDto OK
     * @throws ApiError
     */
    public static postApiAppTenantRegistrationRegister(
        requestBody?: Routemize_DTOs_TenantRegistrationDto,
    ): CancelablePromise<Routemize_DTOs_TenantRegistrationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/tenantRegistration/register',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
